import React from "react";
import Wrapper from "../layout/Wrapper";
import BannerComp from "../components/BannerComp/BannerComp";
import assests from "../ui/assests";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";
import TestimonialsComp from "../components/TestimonialsComp/TestimonialsComp";
import SolutionsComp from "../components/SolutionsComp/SolutionsComp";
import ExpertiseToTransform from "../components/SolutionsComp/ExpertiseToTransform";

export default function Solutions() {
  return (
    <Wrapper>
      <BannerComp
        image={assests.carrerBg}
        title="Build the Future of the Web with Us"
        description="We’re a creative web design and development company offering SEO, digital marketing, and complete web solutions—backed by a passionate team delivering excellence to every client."
      />
      <SolutionsComp />
      <ExpertiseToTransform />
      <TestimonialsComp />
      <DesignFutureSec />
    </Wrapper>
  );
}
